import { render } from "./DeliveryModeList.vue?vue&type=template&id=019f9d85"
import script from "./DeliveryModeList.vue?vue&type=script&lang=js"
export * from "./DeliveryModeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__